import axios, { authInstance } from '../config';
import { getToken } from '../../utils/session-utils';

export const sendAuthCode = (
  { mobileNumber, message, voiceOption },
  onSuccess,
  onError
) =>
  authInstance
    .post(
      '/v1/users/token/refresh',
      {
        mobileNumber,
        message
      },
      {
        withCredentials: true,
        params: {
          'send-code-over-voice': voiceOption
        }
      }
    )
    .then(res => onSuccess(res.data))
    .catch(err => onError(err));

export const verifyAuthCode = (
  { mobileNumber, code, kmsi },
  onSuccess,
  onError
) =>
  axios
    .post(
      '/v1/users/token',
      {
        mobileNumber,
        indentificationCode: code
      },
      {
        withCredentials: true,
        headers: {
          'keep-me-signed-in': kmsi
        }
      }
    )
    .then(res => onSuccess(res.data))
    .catch(err => onError('Code is Invalid'));

export const logout = ({ mobileNumber }, onSuccess, onError) =>
  axios
    .post(
      'v1/users/signout',
      {
        mobileNumber
      },
      { withCredentials: true }
    )
    .then(res => onSuccess(res.data))
    .catch(err => onError(err));

export const createUser = (
  {
    firstName,
    lastName,
    dob,
    userName,
    email,
    market,
    branch,
    mobileNumber,
    neverShowAgain
  },
  onSuccess,
  onError
) => {
  axios
    .post(
      '/v1/users/profile',
      {
        firstName,
        lastName,
        dob,
        idOrEmail: email,
        domainUsername: userName,
        ministry: market,
        hospitalName: branch,
        mobileNumber,
        neverShowAgain
      },
      {
        headers: {
          Authorization: getToken()
        }
      }
    )
    .then(res => onSuccess(res.data))
    .catch(err => onError(err.message));
};
